<script setup>
defineProps({
  modelValue: {
    type: [String, Number],
    required: true,
  },
  tabs: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <div class="bottom-tabs-view column no-wrap">
    <slot />
    <q-separator />
    <q-tabs
      class="bottom-tabs"
      :model-value="modelValue"
      align="justify"
      active-color="primary"
      indicator-color="primary"
      @update:model-value="value => emit('update:modelValue', value)"
    >
      <q-tab
        v-for="tab in tabs"
        :key="tab.name"
        :name="tab.name"
        :label="tab.label"
      />
    </q-tabs>
  </div>
</template>

<style scoped lang="scss">
// QPage is position: relative with min-height = visible viewport minus the measured header
.bottom-tabs-view {
  position: absolute;
  inset: 0;
  overflow-x: hidden;
}

.bottom-tabs {
  flex-shrink: 0;
}
</style>
